<template>
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen">
    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">Plan your Leave Days</p>
      </div>
      <div class=" bg-white rounded px-6 py-2">
        <LeavePlanForm
            :view="view"
            :months="months"
            :quarters="quarters"
            @update-plan="updatePlan"
            :leavePlan="leavePlan"
            :type="type"
            :currentQuarter="currentQuarter"
            @refresh-list="getLeavePlan"
        />
      </div>
    </div>
<!--    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">My Leave Plan</p>
      </div>
      <ve-table :columns="columns" :table-data="leavePlanDays" />
      <div
          v-if="!loading && leavePlanDays.length === 0"
          class="flex flex-col justify-center items-center h-full mt-5"
      >
        <el-empty :image-size="70" description="No Data"></el-empty>
      </div>
    </div>-->
  </div>
</template>

<script>
import LeavePlanForm from "@/components/timeoff/LeavePlanForm";
import axios from "axios";
import {mapGetters} from "vuex";
export default {
  components: {
    LeavePlanForm,
  },
  data() {
    return {
      view: 'monthly',  // default view
      months: ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'],
      type:'Personal',
      tableData: [],
      quarters: ['Q1', 'Q2', 'Q3', 'Q4'],
      currentQuarter: 1,
      loading:false,
      leavePlanDays:[],
      leavePlan: {}
    };

  },
  computed:{
    ...mapGetters(["getOrganization", "getToken"]),
    columns() {
      const monthColumns = this.months.map((month) => ({
        field: month,
        key: month,
        title: month,
        renderBodyCell: ({ row }) => {
          console.log(row)
          return row[month] || 0; // Show 0 if no leave days are planned
        },
      }));

      // Combine the base columns and dynamic month columns
      return monthColumns;
    },
  },
  methods: {
    setView(viewType) {
      this.view = viewType;
    },
    updatePlan(updatedPlan) {
      this.leavePlan = updatedPlan;
    },
    getLeavePlan(){
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(`${this.getOrganization}/timeoff/plan/${this.$ApiVersion}/request`,
          options)
      .then((response)=>{
        this.leavePlanDays = response.data.Data
        this.leavePlan = response.data.Data
      }).catch((error)=>{
        console.log(error)
      })
    }
  },
  created() {
    this.getLeavePlan()
  }
}

</script>
<style>
  table tr th, table tr td {
    text-align: left;
  }
  table tr td span {
    color: #67c23a;
    font-weight: 700;
  }
</style>